import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/views/Login'
import Managers from '@/views/Managers'
import Templates from '@/views/Templates'
import Clients from '@/views/Clients'
import Domestic from '@/views/Domestic'
import Main from '@/views/Main'
import Itinerary from '@/views/Itinerary'

import Transfer from '@/views/Settings/Transfer'
import Exchange from '@/views/Settings/Exchange'
import Smtp from '@/views/Settings/Smtp'
import Airstrip from '@/views/Settings/Airstrip'
import Area from '@/views/Settings/Area'
import Location from '@/views/Settings/Location'
import Territory from '@/views/Settings/Territory'
import Commission from '@/views/Settings/Commission'
import Limits from '@/views/Settings/Limits'
import Mountains from '@/views/Settings/Mountains'
import Texts from '@/views/Settings/Texts'
import Vip from '@/views/Settings/Vip'

import Calculation from '@/views/Safari/Calculation'
import Parks from '@/views/Safari/Parks'
import ParksDetail from '@/views/Safari/ParksDetail'

import CreatedInvoice from "@/components/invoices/CreatedInvoice";

import TripsIsland from '@/views/Trips/Island'
import TripsIslandDetail from '@/views/Trips/IslandDetail'
import TripsTanzania from '@/views/Trips/Tanzania'
import TripsTanzaniaDetail from '@/views/Trips/TanzaniaDetail'
import TripsSafari from '@/views/Trips/Safari'
import TripsSafariDetail from '@/views/Trips/SafariDetail'

import Camps from '@/views/Climbing/Camps'
import Distance from '@/views/Climbing/Distance'
import Temperature from '@/views/Climbing/Temperature'
import Moon from '@/views/Climbing/Moon'
import Additional from '@/views/Climbing/Additional'
import ClimbingPrices from '@/views/Climbing/ClimbingPrices'
import Routes from '@/views/Climbing/Routes'
import RoutesDetail from '@/views/Climbing/RoutesDetail'

import Hotels from '@/views/Hotels/Hotels'
import HotelsDetail from '@/views/Hotels/HotelsDetail'

import HotelsAdvanced from '@/views/Hotels/HotelsAdvanced'
import HotelsAdvancedDetailHotel from '@/views/Hotels/HotelsAdvancedDetailHotel'
import HotelsAdvancedDetailRooms from '@/views/Hotels/HotelsAdvancedDetailRooms'
import HotelsAdvancedDetailSeasons from '@/views/Hotels/HotelsAdvancedDetailSeasons'
import HotelsAdvancedDetailPrices from '@/views/Hotels/HotelsAdvancedDetailPrices'
import HotelsAdvancedDetailAdditional from '@/views/Hotels/HotelsAdvancedDetailAdditional'
import HotelsAdvancedDetailCamps from '@/views/Hotels/HotelsAdvancedDetailCamps'
import HotelsAdvancedDetailAdditionalPrices from '@/views/Hotels/HotelsAdvancedDetailAdditionalPrices'
import HotelsAdvancedDetailOffers from '@/views/Hotels/HotelsAdvancedDetailOffers'
import HotelsAdvancedDetailHistory from '@/views/Hotels/HotelsAdvancedDetailHistory'

import {getUserRoles} from '@/utilites/api'
import Banks from "@/views/Banks/Banks";
import Partners from "@/views/Partners/Partners";
import AllInvoices from "@/components/invoices/AllInvoices";
import createdInvoice from "@/components/invoices/CreatedInvoice";
import ChangeInvoice from "@/components/invoices/ChangeInvoice";
import InvoiceChared from "@/views/InvoiceChared";
import EFDInvoice from "@/components/invoices/EFDInvoice";
import InvoicePaymentResult from "@/components/invoices/InvoicePaymentResult";
import CreateDubliAteInvoice from "@/components/invoices/CreateDubliсateInvoice";
import AllClients from "@/components/Clients/AllClients";
import DetailsInvoice from "@/components/invoices/DetailsInvoice";
import EmailTemplate from "@/views/Settings/EmailTemplate";
import ClimbingPricesNew from "@/views/Climbing/ClimbingPricesNew.vue";
import ClimbingInclusionsExclusions from "@/views/Climbing/ClimbingInclusionsExclusions.vue";
import HotelsAdvancedDetailPaymentPolicy from "@/views/Hotels/HotelsAdvancedDetailPaymentPolicy.vue";
import Aircrafts from "@/views/Aircrafts/Aircrafts.vue";
import HotelsAdvancedDetailStaffAccommodation from '@/views/Hotels/HotelsAdvancedDetailStaffAccommodation.vue'
import HotelsAdvancedDetailSafetyMeasurements from '@/views/Hotels/HotelsAdvancedDetailSafetyMeasurements.vue'

Vue.use(Router)

const BRANDING = process.env.VUE_APP_BRANDING

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      beforeEnter() {
        window.location.href =
          BRANDING === 'false'
            ? 'https://altezza.travel/'
            : 'https://www.google.com/'
      },
    },
    {
      path: '/marsel',
      component: Login,
      name: 'login',
      meta: {
        auth: false,
      },
    },
    {
      path: '/managers',
      component: Managers,
      name: 'managers',
      meta: {
        auth: true,
        sales: false,
        content: false,
      },
    },
    {
      path: '/templates',
      component: Templates,
      name: 'templates',
      meta: {
        auth: true,
        sales: true,
        content: true,
      },
    },
    {
      path: '/new',
      component: Main,
      name: 'create',
      meta: {
        auth: true,
        sales: true,
        content: true,
      },
    },
    {
      path: '/templates/:id',
      component: Main,
      name: 'template',
      meta: {
        auth: true,
        sales: true,
        content: true,
      },
    },
    {
      path: '/clients/:id',
      component: Main,
      name: 'client',
      meta: {
        auth: true,
        sales: true,
        content: true,
      },
    },
    {
      path: '/clients',
      component: Clients,
      name: 'clients',
      meta: {
        auth: true,
        sales: true,
        content: true,
      },
    },
    {
      path: '/domestic',
      component: Domestic,
      name: 'domestic',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/settings/transfer',
      component: Transfer,
      name: 'settings-transfer',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/settings/exchange',
      component: Exchange,
      name: 'settings-exchange',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/settings/smtp',
      component: Smtp,
      name: 'settings-smtp',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/settings/airstrip',
      component: Airstrip,
      name: 'settings-airstrip',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/settings/area',
      component: Area,
      name: 'settings-area',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/settings/location',
      component: Location,
      name: 'settings-location',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/settings/email-template',
      component: EmailTemplate,
      name: 'email-template',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/settings/territory',
      component: Territory,
      name: 'settings-territory',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/settings/commission',
      component: Commission,
      name: 'settings-commission',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/settings/limits',
      component: Limits,
      name: 'settings-limits',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/settings/mountains',
      component: Mountains,
      name: 'settings-mountains',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/settings/texts',
      component: Texts,
      name: 'texts',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/settings/vip-service',
      component: Vip,
      name: 'vip-service',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/safari/calculation',
      component: Calculation,
      name: 'safari-calculation',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/safari/parks',
      component: Parks,
      name: 'safari-parks',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/safari/parks/add',
      component: ParksDetail,
      name: 'safari-parks-add',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/safari/parks/:id',
      component: ParksDetail,
      name: 'safari-parks-detail',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/trips/island',
      component: TripsIsland,
      name: 'trips-island',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/trips/island/add',
      component: TripsIslandDetail,
      name: 'trips-island-add',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/trips/island/:id',
      component: TripsIslandDetail,
      name: 'trips-island-detail',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/trips/tanzania',
      component: TripsTanzania,
      name: 'trips-tanzania',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/trips/tanzania/add',
      component: TripsTanzaniaDetail,
      name: 'trips-tanzania-add',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/trips/tanzania/:id',
      component: TripsTanzaniaDetail,
      name: 'trips-tanzania-detail',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/trips/safari',
      component: TripsSafari,
      name: 'trips-safari',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/trips/safari/add',
      component: TripsSafariDetail,
      name: 'trips-safari-add',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/trips/safari/:id',
      component: TripsSafariDetail,
      name: 'trips-safari-detail',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/climbing/camps',
      component: Camps,
      name: 'climbing-camps',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/climbing/distance',
      component: Distance,
      name: 'climbing-distance',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/climbing/temperature',
      component: Temperature,
      name: 'climbing-temperature',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/climbing/moon',
      component: Moon,
      name: 'climbing-moon',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/climbing/routes',
      component: Routes,
      name: 'climbing-routes',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/climbing/additional',
      component: Additional,
      name: 'climbing-additional',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/climbing/prices-old',
      component: ClimbingPrices,
      name: 'climbing-prices-old',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/climbing/prices',
      component: ClimbingPricesNew,
      name: 'climbing-prices',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/climbing/inclusions',
      component: ClimbingInclusionsExclusions,
      name: 'climbing-inclusions-exclusions',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/climbing/routes/add',
      component: RoutesDetail,
      name: 'climbing-routes-add',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/climbing/routes/:id',
      component: RoutesDetail,
      name: 'climbing-routes-detail',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    // {
    //     path : '/hotels',
    //     component: Hotels,
    //     name: 'hotels',
    //     meta: {
    //         auth: true,
    //         sales: false,
    //         content: true
    //     }
    // },
    // {
    //     path : '/hotels/add',
    //     component: HotelsDetail,
    //     name: 'hotels-add',
    //     meta: {
    //         auth: true,
    //         sales: false,
    //         content: true
    //     }
    // },


    {
      path: '/hotels',
      component: HotelsAdvanced,
      name: 'hotels-advanced',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/hotels/:id/hotel',
      component: HotelsAdvancedDetailHotel,
      name: 'hotels-advanced-add-hotel',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/hotels/:id/additional',
      component: HotelsAdvancedDetailAdditional,
      name: 'hotels-advanced-add-additional',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/hotels/:id/mobile-camps',
      component: HotelsAdvancedDetailCamps,
      name: 'hotels-advanced-add-mobile-camps',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/hotels/:id/rooms',
      component: HotelsAdvancedDetailRooms,
      name: 'hotels-advanced-add-rooms',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/hotels/:id/seasons',
      component: HotelsAdvancedDetailSeasons,
      name: 'hotels-advanced-add-seasons',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/hotels/:id/staff-accommodation',
      component: HotelsAdvancedDetailStaffAccommodation,
      name: 'hotel-staff-accommodation',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/hotels/:id/safety-measurements',
      component: HotelsAdvancedDetailSafetyMeasurements,
      name: 'hotel-safety-measurements',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/hotels/:id/prices',
      component: HotelsAdvancedDetailPrices,
      name: 'hotels-advanced-add-prices',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/hotels/:id/additional-prices',
      component: HotelsAdvancedDetailAdditionalPrices,
      name: 'hotels-advanced-add-additional-prices',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/hotels/:id/offers',
      component: HotelsAdvancedDetailOffers,
      name: 'hotels-advanced-add-offers',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/hotels/:id/history',
      component: HotelsAdvancedDetailHistory,
      name: 'hotels-advanced-add-history',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/hotels/:id/payment-policy',
      component: HotelsAdvancedDetailPaymentPolicy,
      name: 'hotels-advanced-payment-policy',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    // {
    //     path : '/hotels/:id',
    //     component: HotelsDetail,
    //     name: 'hotels-detail',
    //     meta: {
    //         auth: true,
    //         sales: false,
    //         content: true
    //     }
    // },
    {
      path: '/banks',
      component: Banks,
      name: 'banks',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/partners',
      component: Partners,
      name: 'partners',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/settings/aircrafts',
      component: Aircrafts,
      name: 'settings-aircrafts',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/createdInvoices/client/:id',
      component: createdInvoice,
      name: 'createdInvoice',
      meta: {
        auth: true,
        sales: true,
        content: true,
      },
    },
    {
      path: '/allInvoices',
      component: AllInvoices,
      name: 'allInvoices',
      meta: {
        auth: true,
        sales: true,
        content: true,
      },
    },
    {
      path: '/all-clients',
      component: AllClients,
      name: 'all-clients',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/efd',
      component: EFDInvoice,
      name: 'efd',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '/changeInvoice/:id',
      component: ChangeInvoice,
      name: 'changeInvoice',
      meta: {
        auth: true,
        sales: true,
        content: true,
      },
    },
    {
      path: '/createDublicateInvoice/:id',
      component: CreateDubliAteInvoice,
      name: 'createDublicateInvoice',
      meta: {
        auth: true,
        sales: true,
        content: true,
      },
    },
    {
      path: '/itinerary/:link',
      component: Itinerary,
      name: 'itinerary',
      meta: {
        auth: true,
        sales: true,
        content: true,
      },
    },
    {
      path: '/invoice/shared/:link',
      component: InvoiceChared,
      name: 'invoice-shared',
      meta: {
        auth: true,
        sales: true,
        content: true,
      },
    },
    {
      path: '/invoice/payment/result/:link',
      component: InvoicePaymentResult,
      name: 'invoice-payment-result',
      meta: {
        auth: true,
        sales: true,
        content: true,
      },
    },
    {
      path: '/details_invoice/:id',
      component: DetailsInvoice,
      name: 'details-invoice',
      meta: {
        auth: true,
        sales: false,
        content: true,
      },
    },
    {
      path: '*',
      redirect: '/clients',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const roles = getUserRoles()
  // console.log('roles', roles)
  if (roles === null) {
    next()
    return
  }
  if (roles.includes('ADMIN')) {
    next()
    return
  }
  if (roles.includes('CONTENT')) {
    if (to.meta.content) {
      next()
      return
    } else {
      next({
        path: '/clients',
      })
      return
    }
  }
  if (roles.includes('SALES')) {
    if (to.meta.sales) {
      next()
      return
    } else {
      next({
        path: '/clients',
      })
      return
    }
  }
  // if(to.meta.sales === false && roles.includes('SALES'))
  // if(to.meta.sales && roles.includes('SALES')){
  //     next()
  // } else if (to.meta.sales && !roles.includes('SALES')) {
  //     next({
  //         path: '/clients'
  //     })
  // }
  next()
})
export default router
